<div *ngFor="let socialMediaField of socialMediaSettings.SocialMediaFields">
  <div class="col-sm-6">
    <label> <input class="control-label" type="checkbox" [(ngModel)]="socialMediaField.Visible" /> {{ socialMediaField.Name }} </label>
    <input
      class="pull-right"
      type="text"
      [(ngModel)]="socialMediaField.HelpText"
      placeholder="{{ 'common.placeholder-text' | translate | titlecase }}"
    />
  </div>
</div>
